import React, { useState, useEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useNavigate } from 'react-router-dom';

const BasicInfoForm = () => {
  const [localChannelName, setLocalChannelName] = useState(localStorage.getItem('channelName') || '');
  const [localFirstName, setLocalFirstName] = useState(localStorage.getItem('firstName') || '');
  const [localLastName, setLocalLastName] = useState(localStorage.getItem('lastName') || '');
  const [localPhoneNumber, setLocalPhoneNumber] = useState(localStorage.getItem('phoneNumber') || '');
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem('channelName', localChannelName);
    localStorage.setItem('firstName', localFirstName);
    localStorage.setItem('lastName', localLastName);
    localStorage.setItem('phoneNumber', localPhoneNumber);
  }, [localChannelName, localFirstName, localLastName, localPhoneNumber]);

  const handleChannelNameChange = (e) => {
    setLocalChannelName(e.target.value);
  };

  const handleFirstNameChange = (e) => {
    setLocalFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLocalLastName(e.target.value);
  };
  const handlePhoneNumberChange = (value) => {
    setLocalPhoneNumber(value);
  };

  const isAllFieldsFilled = localChannelName !== '' && localFirstName !== '' && localLastName !== '' && localPhoneNumber !== '';

 
  const handleSelectUploaderPassClick = () => {
    if (isAllFieldsFilled) {
      navigate('/BecomeUploaderNew', { state: { activeTab: 'Select Uploader Pass' } });
    }
  };


  const handleCancelClick = () => {
    setLocalChannelName('');
    setLocalFirstName('');
    setLocalLastName('');
    setLocalPhoneNumber('');
  };

  return (
    <div>
      <div className="mx-auto max-w-2xl text-center mt-8">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="mb-4">
            <label htmlFor="channelName" className="block text-left mb-1">
              Channel name
              {localChannelName === '' && (
                <span className="text-red-500">*</span>
              )}
            </label>
            <input
              type="text"
              id="channelName"
              placeholder="Channel name"
              value={localChannelName}
              onChange={handleChannelNameChange}
              className="w-90 h-12 block w-full border-black-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="firstName" className="block text-left mb-1">
              First name
              {localFirstName === '' && (
                <span className="text-red-500">*</span>
              )}
            </label>
            <input
              type="text"
              id="firstName"
              placeholder="First name"
              value={localFirstName}
              onChange={handleFirstNameChange}
              className="w-80 h-12 block w-full border-black-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="lastName" className="block text-left mb-1">
              Last name
              {localLastName === '' && (
                <span className="text-red-500">*</span>
              )}
            </label>
            <input
              type="text"
              id="lastName"
              placeholder="Last name"
              value={localLastName}
              onChange={handleLastNameChange}
              className="w-80 h-12 block w-full border-black-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="phoneNumber" className="block text-left mb-1">
              Phone Number
              {localPhoneNumber === '' && (
                <span className="text-red-500">*</span>
              )}
            </label>
            <PhoneInput
              country="US"
              placeholder="Phone number"
              value={localPhoneNumber}
              onChange={handlePhoneNumberChange}
              className="w-full h-12 border-black-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div className="flex justify-center mb-5">
            <button
              type="button"
              className="rounded-md bg-red-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 flex items-center"
              onClick={handleCancelClick}
            >
              Cancel
              <span className="ml-1">
                <XMarkIcon className="h-5 w-5 text-white font-bold" aria-hidden="true" />
              </span>
            </button>
            <button
              type="button"
              className={`ml-5 rounded-md ${isAllFieldsFilled ? 'bg-green-600' : 'bg-green-300'} px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 flex items-center`}
              disabled={!isAllFieldsFilled}
              onClick={handleSelectUploaderPassClick}
            >
              Next
              <span className="ml-1">
                <ArrowRightIcon className="h-5 w-5 text-white font-bold" aria-hidden="true" />
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BasicInfoForm;
